export const SECTIONS_INVENTORY_MANAGEMENT = Object.freeze({
    TRANSFER: 'transfer',
    DISCOUNT: 'discount',
    ADD: 'add'
})

export const TYPES_SEARCH_PRODUCTION_ITEM = {
    BAR_CODE: 'BAR_CODE',
    NAME: 'NAME'
} as const
